import { CHANNEL_CATEGORY_LIST } from "../../../Actions/Constants";

const initialState = {
    categories: [],
};

export default function channelCategoryReducer(state = initialState, action) {
    switch (action.type) {
        case CHANNEL_CATEGORY_LIST:
            return { ...state, categories: action.payload };
        default:
            return state;
    }
}